import React, { Component } from "react";

export default class TabCircles extends Component {
    render() {
        const p = this.props;
        const arr = new Array(parseInt(p.length, 10)).fill(0).map((item, index) => index + 1);

        const items = arr.map(function(item, index) {
            return renderItem(item, p.currentTabId, p.circleClick);
        });

    return (
<div className="tab-circles">
        {items}
</div>
            );
    }
}

function renderItem(sequence, currentTabId, circleClick)
{
    if (sequence === currentTabId) {
        return <div key={sequence} className="tab-circle current" />;
    }
    return <div key={sequence} onClick={() => circleClick(sequence)} className="tab-circle non-current" />;
}
